import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { SectionsService } from '../../../../services/sections.service';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { ClaimsService } from '../../../../services/claims.service';
import { UserService } from '../../../../services/user.service';
import { AuthorizeButtonDirective } from '../../../../shared/authorization/authorizeButton.directive';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { AutoFocusHeaderDirective } from '../../../../shared/directives/auto-focus-header.directive';

@Component({
  selector: 'ppl-authorizations-list',
  standalone: true,
  imports: [ButtonComponent, ListTableComponent, AuthorizeButtonDirective, AutoFocusHeaderDirective],
  templateUrl: './authorizations-list.component.html',
  styleUrl: './authorizations-list.component.css',
})
export class AuthorizationsListComponent implements OnInit {
  pageId: string = PAGE_CONSTANTS.AUTHORIZATION_DATA_GRID_PAGE;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any = [];
  lazyLoad = true;
  isPageRestrictionLoaded = false;
  @Input() isReadOnly = false;

  data = [
    {
      clientAuth: 'PRC-NY-10000733',
      pplAuth: 'PPL-NY-10000733',
      consumerFirstName: 'Nikhil',
      consumerLastName: 'Peter',
      medicaid: 'PRV-NY-10000722',
      pplId: 'PPL-NY-10000733',
      hcpcsServiceCode: '112233',
      modifier1: 'Nikhil Malhotra',
      modifier2: 'Sumit Murgai',
      units: '20',
      dollars: 'Rate Participant',
      authStartDate: '2024-10-01',
      authEndDate: '2024-10-05',
      mcoId: '123'
    },
    {
      clientAuth: 'PRC-NY-10000733',
      pplAuth: 'PPL-NY-10000733',
      consumerFirstName: 'Venkat',
      consumerLastName: 'Peter',
      medicaid: 'PRV-NY-10000722',
      pplId: 'PPL-NY-10000733',
      hcpcsServiceCode: '112233',
      modifier1: 'Nikhil Malhotra',
      modifier2: 'Sumit Murgai',
      units: '20',
      dollars: 'Rate Participant',
      authStartDate: '2024-10-01',
      authEndDate: '2024-10-05',
      mcoId: '123'
    },
  ]

  constructor(
    private router: Router,
    private sectionsService: SectionsService,
    private claimsService: ClaimsService,
    private userService: UserService,
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService
  ) {
  }

  ngOnInit() {
    this.sectionsService.setFlow('authorizations');
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }
  onAddAuthorizations() {
    console.log('process code add button clicked');
    this.router.navigate(['/home/addAuthorizations']);
  }

  rowClicked(rowDetail: any) {
    this.claimsService.clearAuthData();
    this.userService.setLeadEntry('authorizations');
    this.userService.setSelectedLead(rowDetail.authorizationId);  //rowDetail.referral_participant_id
    setTimeout(() => {
      this.router.navigate(['/home/authorizations/details/']);
    }, 200);
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService.fetchPageAuthorization(this.programName, this.pageId, "LIST").subscribe(response => {
        this.setRestrictions(response);
      })
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(pageConfig, this.pageId);
      this.actionsToBeHidden = this.authUtility.getHiddenActions(pageConfig, this.pageId);
      this.isReadOnly = this.authUtility.isRestrictiedAction(this.pageId, 'EditAuthorization');
    }
    this.isPageRestrictionLoaded = true;
  }
}
